class SimpleCartTracker {
  constructor() {
    this.writeDelay = 800; // ms na cart mutatie
    this.checkoutDelay = 350; // ms voor redirect naar checkout
    this.init();
  }

  async init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.addTrackingToCart();
    });

    this.interceptCartUpdates();
    this.interceptCheckout();
  }

  async addTrackingToCart() {
    if (!window.clickTracker) return;

    const trackingData = window.clickTracker.getData();
    if (!trackingData || Object.keys(trackingData).length === 0) return;

    const cart = await this.getCart();
    if (cart.item_count === 0) return;

    await this.updateCartWithTracking(trackingData);
  }

  async getCart() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (e) {
      return { item_count: 0 };
    }
  }

  async updateCartWithTracking(trackingData) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          attributes: {
            tracking_data: JSON.stringify(trackingData)
          }
        })
      });
    } catch (e) {
      console.error('[CartTracker] Kon tracking data niet schrijven:', e);
    }
  }

  interceptCartUpdates() {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change')
      ) {
        setTimeout(() => this.addTrackingToCart(), this.writeDelay);
      }

      return response;
    };
  }

  interceptCheckout() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(
        '[name="checkout"], [href="/checkout"], #checkout, .cart__checkout, [data-checkout-btn]'
      );

      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      this.addTrackingToCart().finally(() => {
        setTimeout(() => {
          const target = btn.getAttribute('href') || '/checkout';
          window.location.href = target;
        }, this.checkoutDelay);
      });
    }, true);
  }
}

new SimpleCartTracker();